// MateriaisPage.js

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import MaterialModal from '../../components/MaterialModal.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../config/axiosConfig';
import '../../components/MateriaisPage.css';

function MateriaisPage() {
  const [materiais, setMateriais] = useState([]);
  const [materialSelecionado, setMaterialSelecionado] = useState(null);
  const { theme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Usando o axiosConfig para buscar materiais
    api.get('/materiais/listarmateriais')
      .then((response) => {
        if (Array.isArray(response.data)) {
          setMateriais(response.data); // Garante que estamos trabalhando com um array
        } else {
          console.error('A resposta não contém um array de materiais:', response.data);
        }
      })
      .catch((error) => {
        console.error('Erro ao buscar materiais:', error);
      });
  }, []);

  const handleFechar = () => {
    const previousPage = location.state?.from || '/home';
    navigate(previousPage);
  };

  const handleAdicionarMaterial = (material) => {
    const codigoExistente = materiais.some(p => p.codmat === material.codmat && p.id !== material.id);
    if (codigoExistente) {
      window.alert('Atenção... Código do Material já existe no Cadastro.');
    } else {
      const method = material.id ? 'PUT' : 'POST';
      const url = material.id ? '/materiais/alterarmaterial' : '/materiais/cadastrarmaterial';

      api({
        url,
        method,
        data: material,
      })
        .then((response) => {
          const data = response.data;
          if (data && data.codmat && data.material) {
            console.log('Material salvo:', data);
            if (material.id) {
              setMateriais(materiais.map(p => (p.id === material.id ? data : p)));
            } else {
              setMateriais([...materiais, data]);
            }
            setMaterialSelecionado(null);
          } else {
            console.error('Dados inválidos recebidos ao salvar o material:', data);
          }
        })
        .catch((error) => {
          console.error('Erro ao salvar material:', error);
        });
    }
  };

  const handleSelecionarMaterial = (indice) => {
    setMaterialSelecionado(materiais[indice]);
  };

  const handleExcluirMaterial = (indice) => {
    const material = materiais[indice];
    api.delete(`/materiais/excluirmaterial/${material.id}`)
      .then(() => {
        setMateriais(materiais.filter((_, i) => i !== indice));
      })
      .catch((error) => {
        console.error('Erro ao excluir material:', error);
      });
  };

  // Função para formatar os valores para BRL
  const formatarValorBRL = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  return (
    <div style={{ 
      backgroundColor: theme.background, 
      color: theme.color,
      minHeight: 'calc(100vh - 20px)',
      width: '100%',
      paddingTop: '10px'
    }}>
      <Header selectedCompany={localStorage.getItem('selectedCompany')} />
      
      <div className="title-actions-container">
        <button 
          onClick={() => setMaterialSelecionado({ codmat: '', material: '', valcompra: '' })} 
          className="btn btn-primary" 
          style={{ padding: '5px 10px', fontSize: '14px', marginLeft: '100px' }}
        >
          Adicionar
        </button>
        <h3>Tabela de Materiais - Compras</h3>
        <button 
          onClick={handleFechar} 
          className="btn btn-primary" 
          style={{ padding: '5px 10px', fontSize: '14px', marginRight: '100px' }}
        >
          Fechar
        </button>
      </div>
      
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th className="col-codigo">Código</th>
              <th className="col-material">Material</th>
              <th className="col-valor">Valor</th>
              <th className="col-selecionar">Seleção</th>
              <th className="col-excluir">Excluir</th>
            </tr>
          </thead>
          <tbody>
            {materiais.map((obj, indice) => (
              <tr key={indice}>
                <td>{obj.codmat}</td>
                <td>{obj.material}</td>
                <td>{formatarValorBRL(obj.valcompra)}</td>
                <td>
                  <button 
                    onClick={() => handleSelecionarMaterial(indice)} 
                    className="btn btn-success" 
                    style={{ padding: '4px 6px', fontSize: '12px' }}
                  >
                    Sel
                  </button>
                </td>
                <td>
                  <button 
                    onClick={() => handleExcluirMaterial(indice)} 
                    className="btn btn-danger" 
                    style={{ padding: '4px 8px', fontSize: '12px' }}
                  >
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {materialSelecionado && (
        <MaterialModal 
          material={materialSelecionado} 
          onSave={handleAdicionarMaterial} 
          onClose={() => setMaterialSelecionado(null)} 
        />
      )}
    </div>
  );
}

export default MateriaisPage;
